(() => {
  const config = document.getElementById('fmv-catalogue-search-config');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  labels.vat = '(' + labels.vat.replace(/^\s*\(|\)\s*$/g, '').trim() + ')';
  labels.tileExVat = '(' + labels.tileExVat.replace(/^\s*\(|\)\s*$/g, '').trim() + ')';
  const root = window.Shopify?.routes?.root || '/';
  const cataloguePath = root + 'pages/tile-catalogue';
  const selector = '.search__content .product-card, .template-search .product-card, .fmv-home__products .fmv-home__product';
  let cataloguePromise;
  let scheduled = false;
  const money = value => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
  function decode(packed) {
    const strings = packed.strings.map(s => typeof s === 'string' && s.startsWith('@') ? packed.imagePrefix + s.slice(1) : s);
    return { assets: packed.assets, groups: packed.groups.map(g => ({
      name: g[0], description: g[1], rooms: g[2].map(i => typeof i === 'number' ? strings[i] : i),
      options: g[3].map(row => {
        const o = Object.fromEntries(packed.keys.map((key, i) => [key, row[i] ?? null]));
        o.image = o.image === null ? null : strings[o.image];
        if (Number.isInteger(o.spec)) o.spec = Object.fromEntries(packed.specKeys.map((key, i) => [key, packed.specs[o.spec][i]]));
        if (o.purchase) o.handle = packed.handles[o.purchase[1]];
        return o;
      })
    })) };
  }
  async function loadCatalogue() {
    if (!cataloguePromise) cataloguePromise = (async () => {
      let source = document.getElementById('inspire-catalogue-data');
      if (!source) {
        const response = await fetch(cataloguePath, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Catalogue unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        source = doc.getElementById('inspire-catalogue-data');
      }
      if (!source) throw new Error('Catalogue data unavailable');
      const decoded = decode(JSON.parse(source.textContent));
      const atlasMatch = [...source.ownerDocument.scripts].map(s => s.textContent.match(/const atlas=["'](https:\/\/cdn\.shopify\.com\/[^"']+)["']/)).find(Boolean);
      decoded.assets.fmvAtlas = atlasMatch ? {url:atlasMatch[1],width:2048,height:9216,cellWidth:256,cellHeight:192} : null;
      return decoded;
    })();
    return cataloguePromise;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function productUrl(option) {
    if (!option?.handle || !option.purchase?.[0]) return null;
    return root + 'products/' + encodeURIComponent(option.handle) + '?variant=' + encodeURIComponent(option.purchase[0]);
  }
  function catalogueUrl(group, preferredHandle) {
    return productUrl(group.options.find(o => o.handle === preferredHandle))
      || productUrl(group.options.find(o => o.handle))
      || cataloguePath;
  }
  function photo(group, assets) {
    const frame = element('span', 'fmv-search-tile-photo');
    const sample = group.options[0];
    const source = group.rooms[0] || group.options.find(o => o.image)?.image || (sample?.sprite ? {sprite: sample.sprite, caption: sample.label} : sample?.atlas && assets.fmvAtlas ? {sprite:['fmvAtlas',...sample.atlas],caption:sample.label} : null);
    if (typeof source === 'string') {
      const img = element('img');
      img.src = source;
      img.alt = group.name;
      img.loading = 'lazy';
      img.width = 600;
      img.height = 450;
      frame.append(img);
    } else if (source?.sprite) {
      const a = assets[source.sprite[0]];
      if (!a) return null;
      frame.style.backgroundImage = 'url(' + JSON.stringify(a.url) + ')';
      frame.style.backgroundSize = (a.width / a.cellWidth * 100) + '% ' + (a.height / a.cellHeight * 100) + '%';
      frame.style.backgroundPosition = (source.sprite[1] / (a.width - a.cellWidth) * 100) + '% ' + (source.sprite[2] / (a.height - a.cellHeight) * 100) + '%';
      frame.setAttribute('role', 'img');
      frame.setAttribute('aria-label', source.caption || group.name);
    } else return null;
    return frame;
  }
  function priceText(group) {
    const rates = [...new Set(group.options.map(o => o.rate).filter(v => typeof v === 'number'))].sort((a, b) => a - b);
    const units = [...new Set(group.options.map(o => o.unit || 'm2'))];
    if (!rates.length || units.length !== 1) return labels.viewPrices;
    return (rates.length > 1 ? labels.from + ' ' : '') + money(rates[0]) + ' ' + (units[0] === 'box' ? labels.perBox : units[0] === 'piece' ? labels.perPiece : labels.perM2) + ' ' + labels.vat;
  }
  function renderCard(card, group, assets) {
    const picture = photo(group, assets);
    if (!picture) return;
    const existing = card.querySelector('a[href*="/products/"]');
    const preferredHandle = existing ? decodeURIComponent(new URL(existing.href).pathname.split('/products/')[1]?.split('/')[0] || '') : '';
    const url = catalogueUrl(group, preferredHandle);
    const imageLink = element('a', 'fmv-search-tile-image-link');
    imageLink.href = url;
    imageLink.tabIndex = -1;
    imageLink.setAttribute('aria-hidden', 'true');
    imageLink.append(picture);
    const heading = element('h3');
    const title = element('a', '', group.name);
    title.href = url;
    heading.append(title);
    const price = element('p', 'fmv-search-tile-price', (labels.tradeCustomer ? labels.tileRetail + ' ' : '') + priceText(group));
    const colours = new Set(group.options.map(o => o.label)).size;
    const sizes = new Set(group.options.map(o => o.size)).size;
    const count = element('p', 'fmv-search-tile-count', colours + ' ' + labels.colours + ' · ' + sizes + ' ' + (sizes === 1 ? labels.size : labels.sizes));
    const button = element('a', 'fmv-search-tile-button', labels.explore + ' ' + group.name);
    button.href = url;
    card.replaceChildren(imageLink, heading, price, count, button);
    card.classList.add('product-card', 'fmv-search-tile-card');
    card.dataset.fmvCatalogue = group.name;
  }
  async function enhance() {
    for (const card of document.querySelectorAll('#MainContent .product-card, .search__content .product-card')) {
      if (card.classList.contains('fmv-search-tile-card') || card.querySelector('.fmv-product-explore')) continue;
      const title = card.querySelector('.product-card__title a');
      const info = card.querySelector('.product-card__info');
      if (!title || !info) continue;
      const button = element('a', 'fmv-search-tile-button fmv-product-explore', labels.explore);
      button.href = title.href;
      button.setAttribute('aria-label', labels.explore + ' ' + title.textContent.trim());
      info.append(button);
    }
    const cards = [...document.querySelectorAll(selector)].filter(card => !card.dataset.fmvCatalogue);
    if (!cards.length) return;
    try {
      const data = await loadCatalogue();
      const byHandle = new Map();
      for (const group of data.groups) for (const option of group.options) if (option.handle) byHandle.set(option.handle, group);
      for (const card of cards) {
        if (!card.isConnected || card.dataset.fmvCatalogue) continue;
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) continue;
        const handle = new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0];
        const group = byHandle.get(decodeURIComponent(handle || ''));
        if (group) renderCard(card, group, data.assets);
      }
      const seenByGrid = new Map();
      const removedByGrid = new Map();
      for (const card of document.querySelectorAll(selector)) {
        const name = card.dataset.fmvCatalogue;
        if (!name) continue;
        const grid = card.closest('.f-grid, .grid, [role="list"]') || card.parentElement;
        let item = card;
        while (item.parentElement && item.parentElement !== grid) item = item.parentElement;
        let seen = seenByGrid.get(grid);
        if (!seen) seenByGrid.set(grid, seen = new Set());
        if (seen.has(name)) {
          item.remove();
          removedByGrid.set(grid, (removedByGrid.get(grid) || 0) + 1);
        }
        else seen.add(name);
      }
      for (const [grid, removed] of removedByGrid) {
        const section = grid.closest('.template-search');
        const count = section?.querySelector('#ProductCount');
        if (count && !section.querySelector('.pagination') && parseInt(count.textContent, 10) === grid.children.length + removed) {
          count.textContent = count.textContent.replace(/^\s*\d+/, String(grid.children.length));
        }
      }
      const byName = new Map(data.groups.map(group => [group.name.toLowerCase(), group]));
      for (const grid of document.querySelectorAll('.fmv-home__products')) {
        if (grid.querySelector('.fmv-search-tile-card')) {
          const viewAll = grid.previousElementSibling?.querySelector('a');
          if (viewAll) viewAll.href = cataloguePath;
        }
      }
      for (const link of document.querySelectorAll('.search__content a[href*="/collections/"]')) {
        const name = link.textContent.trim().replace(/\s+(?:tile\s+)?collection$/i, '').toLowerCase();
        const group = byName.get(name);
        if (group) link.href = catalogueUrl(group);
      }
    } catch (error) {
      console.warn('Catalogue search cards retained the original product display:', error.message);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  }
  async function openLinkedCollection() {
    if (location.pathname.replace(/\/$/, '') !== cataloguePath) return;
    try {
      const data = await loadCatalogue();
      const byName = new Map(data.groups.map(group => [group.name, group]));
      const convert = () => {
        for (const card of document.querySelectorAll('#inspire-grid > .card')) {
          const group = byName.get(card.querySelector('h3')?.textContent.trim());
          const button = card.querySelector('button');
          if (!group || !button) continue;
          const url = catalogueUrl(group);
          if (url === cataloguePath) continue;
          const link = element('a', 'fmv-search-tile-button', button.textContent);
          link.href = url;
          button.replaceWith(link);
          if (labels.tradeCustomer) {
            const price = card.querySelector('p');
            if (price && !price.dataset.retailLabelled) {
              price.prepend(labels.tileRetail + ' ');
              price.dataset.retailLabelled = 'true';
            }
          }
        }
      };
      convert();
      const grid = document.getElementById('inspire-grid');
      if (grid) new MutationObserver(convert).observe(grid, {childList:true});
      const params = new URLSearchParams(location.search);
      const group = byName.get(params.get('tile_collection'));
      const selected = group?.options.find(o => String(o.purchase?.[0]) === params.get('variant'));
      if (group && catalogueUrl(group) !== cataloguePath) location.replace(productUrl(selected) || catalogueUrl(group));
    } catch (error) {
      console.warn('Native catalogue links could not load:', error.message);
    }
  }
  async function nativeTileDetails() {
    const product = document.querySelector('product-info[id^="MainProduct-"]');
    const handle = product?.dataset.url?.split('/products/')[1];
    const testGroup = labels.testTileGroup;
    if (!handle || (!handle.includes('tile') && !testGroup)) return;
    try {
      const catalogue = testGroup ? {groups:[testGroup], assets:{}} : await loadCatalogue();
      const group = catalogue.groups.find(g => g.options.some(o => o.handle === handle));
      if (!group) return;
      product.classList.add('fmv-tile-template');
      const breadcrumbs = document.querySelector('.section-breadcrumb .breadcrumbs');
      if (breadcrumbs) {
        const backToTiles = element('a', 'fmv-tile-back-button', labels.backToTiles);
        backToTiles.href = cataloguePath;
        breadcrumbs.replaceChildren(backToTiles);
      }
      const variantBlock = product.querySelector('.product__block--variant_picker');
      const quantityBlock = product.querySelector('.product-form__quantity:not(.hidden)');
      if (variantBlock && quantityBlock) {
        variantBlock.classList.add('fmv-tile-options-above-quantity');
        if (!variantBlock.querySelector('.fmv-tile-option-prompt')) {
          variantBlock.prepend(element('p', 'fmv-tile-option-prompt', labels.chooseTile));
        }
        quantityBlock.before(variantBlock);
      }
      const mediaContainer = product.querySelector('.product__media-container');
      if (mediaContainer && !mediaContainer.querySelector('.fmv-tile-extra-gallery')) {
        const imageKey = url => {
          try { return new URL(url, location.origin).pathname.split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); }
          catch { return url; }
        };
        const existingImages = new Set([...mediaContainer.querySelectorAll('img')].map(img => imageKey(img.currentSrc || img.src)));
        const seenRooms = new Set();
        const gallery = element('div', 'fmv-tile-extra-gallery');
        gallery.setAttribute('aria-label', group.name);
        const slider = element('div', 'fmv-tile-image-slider');
        slider.tabIndex = 0;
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-label', group.name);
        const counter = element('p', 'fmv-tile-image-counter');
        for (const room of group.rooms) {
          const key = typeof room === 'string' ? imageKey(room) : JSON.stringify(room.sprite);
          if (testGroup && !labels.importedTileGroup && key === '100322651_T.jpg') continue;
          if (seenRooms.has(key) || (!testGroup && typeof room === 'string' && existingImages.has(key))) continue;
          seenRooms.add(key);
          const roomGroup = {...group, rooms:[room]};
          const thumbnail = photo(roomGroup, catalogue.assets);
          if (!thumbnail) continue;
          const label = room.caption || group.name + ' ' + (seenRooms.size);
          const slide = element('figure', 'fmv-tile-image-slide');
          const img = thumbnail.querySelector('img');
          if (img) { img.alt = label; img.draggable = false; if (!slider.childElementCount) { img.loading = 'eager'; img.fetchPriority = 'high'; } }
          slide.append(thumbnail, element('figcaption', '', label));
          slider.append(slide);
        }
        if (slider.childElementCount) {
          const previous = element('button', 'fmv-tile-image-arrow fmv-tile-image-arrow--previous', '‹');
          const next = element('button', 'fmv-tile-image-arrow fmv-tile-image-arrow--next', '›');
          previous.type = next.type = 'button';
          previous.setAttribute('aria-label', labels.previousImage);
          next.setAttribute('aria-label', labels.nextImage);
          const move = direction => {
            const index = Math.round(slider.scrollLeft / (slider.clientWidth || 1));
            const destination = (index + direction + slider.childElementCount) % slider.childElementCount;
            slider.scrollTo({left:destination * slider.clientWidth, behavior:'smooth'});
          };
          previous.addEventListener('click', () => move(-1));
          next.addEventListener('click', () => move(1));
          previous.hidden = next.hidden = slider.childElementCount < 2;
          const updateCounter = () => {
            counter.textContent = (Math.round(slider.scrollLeft / (slider.clientWidth || 1)) + 1) + ' / ' + slider.childElementCount;
          };
          slider.addEventListener('scroll', updateCounter, {passive:true});
          slider.addEventListener('keydown', event => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            slider.scrollBy({left:slider.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior:'smooth'});
          });
          let drag = null;
          slider.addEventListener('pointerdown', event => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            drag = {x:event.clientX, left:slider.scrollLeft};
            slider.setPointerCapture(event.pointerId);
            slider.classList.add('is-dragging');
          });
          slider.addEventListener('pointermove', event => {
            if (drag) slider.scrollLeft = drag.left + drag.x - event.clientX;
          });
          const endDrag = event => {
            if (!drag) return;
            const distance = drag.x - event.clientX;
            const index = Math.round(drag.left / (slider.clientWidth || 1)) + (Math.abs(distance) > 40 ? Math.sign(distance) : 0);
            drag = null;
            slider.classList.remove('is-dragging');
            slider.scrollTo({left:Math.max(0, Math.min(slider.childElementCount - 1, index)) * slider.clientWidth, behavior:'smooth'});
          };
          slider.addEventListener('pointerup', endDrag);
          slider.addEventListener('pointercancel', endDrag);
          slider.addEventListener('lostpointercapture', () => { drag = null; slider.classList.remove('is-dragging'); });
          const stage = element('div', 'fmv-tile-image-stage');
          stage.append(slider, previous, next);
          gallery.append(stage, counter);
          mediaContainer.prepend(gallery);
          if (testGroup && !labels.importedTileGroup) {
            const nativeGallery = mediaContainer.querySelector('media-gallery');
            const tileThumbnail = [...(nativeGallery?.querySelectorAll('[data-target][data-media-position]') || [])]
              .find(item => {
                const img = item.querySelector('img');
                return img && imageKey(img.currentSrc || img.src) === '100322651_T.jpg';
              });
            if (nativeGallery && tileThumbnail) {
              customElements.whenDefined('media-gallery').then(() => {
                if (!nativeGallery.isConnected) return;
                nativeGallery.init();
                nativeGallery.setActiveMedia({featured_media:{
                  id: tileThumbnail.dataset.target,
                  position: Number(tileThumbnail.dataset.mediaPosition),
                  media_type: 'image'
                }});
              }).catch(error => console.warn('Tile close-up selection unavailable:', error.message));
            }
          }
          updateCounter();
        }
      }
      const info = product.querySelector('.product__info-wrapper');
      const intro = element('div', 'fmv-tile-intro');
      intro.append(element('p', 'fmv-tile-range-name', group.name), element('p', '', group.description || ''));
      if (info) info.prepend(intro);
      const specifications = element('section', 'fmv-tile-specifications');
      const specificationList = element('dl');
      const supplierDescription = element('p', 'fmv-supplier-description');
      if (labels.importedTileGroup) {
        specifications.classList.add('fmv-split-specifications');
        const descriptionSection = element('section', 'fmv-supplier-section');
        const detailSection = element('section', 'fmv-supplier-section');
        descriptionSection.append(element('h2', '', labels.supplierDescriptionHeading), supplierDescription);
        detailSection.append(element('h2', '', labels.supplierDetailsHeading), specificationList);
        specifications.append(descriptionSection, detailSection);
      } else specifications.append(specificationList);
      const specificationTarget = product.querySelector('.fmv-product-details-row [data-block-id="collapsible-row-1"] .accordion-details__content');
      const originalSpecifications = specificationTarget ? [...specificationTarget.childNodes] : [];
      const details = element('section', 'fmv-native-tile-details');
      details.setAttribute('aria-label', labels.tileDetails);
      const output = element('div');
      output.setAttribute('aria-live', 'polite');
      details.append(output);
      product.querySelector('[id^="price-"]')?.after(details);
      let last = '';
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const referenceLabel = product.querySelector('.product__sku > span:first-child');
        if (referenceLabel) referenceLabel.textContent = labels.tileReference + ':';
        const form = product.querySelector('form.main-product-form');
        const variantId = form?.elements.namedItem('id')?.value;
        const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
        const option = group.options.find(o => o.handle === handle && String(o.purchase?.[0]) === variantId);
        const source = product.querySelector('[data-fmv-unit-price]');
        const trade = product.querySelector('fmv-trade-price');
        const confirmed = !trade || (!trade.hidden && trade.dataset.variant === variantId && trade.dataset.tradeCents !== undefined);
        const priceMatches = source?.dataset.fmvVariant === variantId;
        const price = priceMatches && confirmed ? Number(trade ? trade.dataset.tradeCents : source.dataset.fmvUnitPrice) : null;
        const retail = trade ? Number(trade.dataset.retail) : price;
        const ready = Boolean(option && price !== null && Number.isFinite(price) && Number.isFinite(retail));
        product.classList.toggle('fmv-tile-pricing-ready', ready);
        const titleBlock = product.querySelector('.product__block--title');
        let tradeSummary = titleBlock?.querySelector('.fmv-tile-trade-summary');
        if (titleBlock && !tradeSummary) {
          tradeSummary = element('div', 'fmv-tile-trade-summary');
          tradeSummary.setAttribute('aria-live', 'polite');
          const title = titleBlock.querySelector('.product__title');
          if (title) title.after(tradeSummary);
          else titleBlock.append(tradeSummary);
        }
        if (tradeSummary) tradeSummary.hidden = !trade || !ready || !Number(option?.pack?.coverage || option?.spec?.coverage) || (option.unit && option.unit !== 'm2');
        let retailReference = titleBlock?.querySelector('.fmv-tile-retail-reference:not(.fmv-tile-retail-m2)');
        if (titleBlock && !retailReference) {
          retailReference = element('p', 'fmv-tile-retail-reference');
          titleBlock.append(retailReference);
        }
        if (retailReference) {
          retailReference.hidden = !trade || !ready || Boolean(option?.promotion);
          retailReference.textContent = trade && ready
            ? labels.tileRetail + ' ' + money(retail / 100) + ' ' + (option.unit === 'piece' ? labels.perPiece : labels.perBox) + ' ' + labels.vat
            : '';
        }
        const pack = option?.pack || option?.spec;
        const coverage = Number(pack?.coverage);
        const validCoverage = Number.isFinite(coverage) && coverage > 0;
        let retailM2 = titleBlock?.querySelector('.fmv-tile-retail-m2');
        if (retailReference && !retailM2) {
          retailM2 = element('p', 'fmv-tile-retail-reference fmv-tile-retail-m2');
          retailReference.before(retailM2);
        }
        if (retailM2) {
          const showRetailM2 = Boolean(trade && ready && validCoverage && !option?.promotion && (!option.unit || option.unit === 'm2'));
          retailM2.hidden = !showRetailM2;
          retailM2.textContent = showRetailM2
            ? labels.tileRetail + ' ' + money(retail / 100 / coverage) + ' ' + labels.perM2 + ' ' + labels.vat
            : '';
        }
        let promotionSummary = titleBlock?.querySelector('.fmv-tile-promotion-summary');
        if (titleBlock && option?.promotion && !promotionSummary) {
          promotionSummary = element('div', 'fmv-tile-promotion-summary');
          titleBlock.append(promotionSummary);
        }
        if (promotionSummary) {
          const promo = option?.promotion;
          const showPromotion = validCoverage && Number.isSafeInteger(promo?.price) && Number.isSafeInteger(promo?.original) && promo.original > promo.price;
          const promoKey = JSON.stringify([variantId, showPromotion, promo, coverage]);
          promotionSummary.hidden = !showPromotion;
          const saleBadge = product.querySelector('.f-badge--sale');
          const productTitle = titleBlock?.querySelector('.product__title');
          if (showPromotion && saleBadge) {
            product.querySelectorAll('.f-badge--sale').forEach(badge => {
              if (badge !== saleBadge) badge.remove();
            });
          }
          if (showPromotion && saleBadge && productTitle) {
            saleBadge.classList.add('fmv-tile-promotion-badge');
            if (labels.tradeCustomer) {
              const savingText = labels.importedTileGroup
                ? labels.promotionRetailSavingDynamic.replace('__percentage__', Math.round((1 - promo.price / promo.original) * 100))
                : labels.promotionRetailSaving;
              if (saleBadge.textContent !== savingText) saleBadge.textContent = savingText;
              if (promotionSummary.previousElementSibling !== saleBadge) promotionSummary.before(saleBadge);
            } else if (saleBadge.parentElement !== titleBlock) {
              productTitle.after(saleBadge);
            }
            if (labels.importedTileGroup && !labels.tradeCustomer) {
              const savingText = labels.promotionSavingDynamic.replace('__percentage__', Math.round((1 - promo.price / promo.original) * 100));
              if (saleBadge.textContent !== savingText) saleBadge.textContent = savingText;
            }
          }
          if (promotionSummary.dataset.key !== promoKey) {
            promotionSummary.dataset.key = promoKey;
            promotionSummary.replaceChildren();
            if (showPromotion) {
              for (const [divisor, unit] of [[coverage, labels.perM2], [1, labels.perBox]]) {
                const row = element('p', 'fmv-tile-promotion-price');
                const currentPrice = element('span', 'fmv-tile-promotion-current', money(promo.price / 100 / divisor));
                currentPrice.setAttribute('aria-label', labels.promotionRetail + ' ' + currentPrice.textContent);
                const originalPrice = element('s', 'fmv-tile-promotion-original', money(promo.original / 100 / divisor));
                originalPrice.setAttribute('aria-label', labels.promotionOriginal + ' ' + originalPrice.textContent);
                row.append(currentPrice, originalPrice, element('span', 'fmv-tile-promotion-unit', unit));
                promotionSummary.append(row);
              }
              promotionSummary.append(element('small', 'fmv-tile-promotion-vat', labels.vat));
            }
          }
        }
        const key = JSON.stringify([variantId, quantity, price, retail, confirmed]);
        if (key === last) return;
        last = key;
        output.replaceChildren();
        tradeSummary?.replaceChildren();
        specificationList.replaceChildren();
        supplierDescription.textContent = option?.description || '';
        supplierDescription.hidden = !option?.description;
        const line = (text, className = '') => output.append(element('p', className, text));
        if (!option) {
          details.hidden = true;
          if (specificationTarget) specificationTarget.replaceChildren(...originalSpecifications);
          return;
        }
        details.hidden = false;
        const spec = option.spec || {};
        for (const field of (labels.importedTileGroup ? [] : ['size', 'material', 'suitable', 'finish', 'thickness', 'tiles', 'coverage', 'rectified', 'polished', 'slip'])) {
          const raw = field === 'size' ? option.size : (field === 'tiles' || field === 'coverage') ? pack?.[field] : spec[field];
          if (raw === null || raw === undefined || raw === '') continue;
          let value = String(raw);
          if (field === 'size') value = value.replace(/x/gi, ' × ') + 'mm';
          if (field === 'thickness') value += 'mm';
          if (field === 'coverage') value += 'm²';
          const row = element('div');
          row.append(element('dt', '', labels.tileSpecLabels[field]), element('dd', '', value));
          specificationList.append(row);
        }
        if (labels.importedTileGroup) {
          const names = {sku:'Reference', color:'Colour', pcsPerBox:'Tiles per box', adhesiveRequired:'Recommended adhesive reference', groutRequired:'Recommended grout reference', resistanceSlip:'Slip resistance (R rating)', slipResistance:'Slip classification', pendulum:'Pendulum classification', heatingCompatible:'Heating compatible', waterResistant:'Water resistant'};
          for (const item of Object.values(option.supplierDetails || {}).flat()) {
            if (['isTileProduct','isSample','priceGroup','priceUnit'].includes(item.label)) continue;
            const label = names[item.label] || item.label.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, x=>x.toUpperCase());
            const row = element('div');
            row.append(element('dt', '', label), element('dd', '', String(item.value)));
            specificationList.append(row);
          }
        }
        if (specificationTarget) {
          if (specificationList.childElementCount) {
            if (!specificationTarget.contains(specifications)) specificationTarget.replaceChildren(specifications);
            if (labels.importedTileGroup) {
              const host = specificationTarget.closest('details');
              if (host) { host.open = true; host.classList.add('fmv-split-specification-host'); }
            }
          } else {
            specificationTarget.replaceChildren(...originalSpecifications);
          }
        }
        const quantityLabel = product.querySelector('.quantity__label');
        if (quantityLabel) quantityLabel.textContent = option.unit === 'piece' ? labels.tileQuantityPieces : labels.tileQuantityBoxes;
        if (!product.querySelector('.product__sku')) line(labels.tileReference + ': ' + option.sku, 'fmv-tile-reference');
        if (price !== null && Number.isFinite(price)) {
          const unit = option.unit === 'piece' ? labels.perPiece : labels.perBox;
          if (validCoverage && (!option.unit || option.unit === 'm2')) {
            const unitPrice = element('p', 'fmv-tile-unit-price');
            unitPrice.append(
              element('span', '', (trade ? labels.tileTrade.replace(/:\s*$/, '') + ' m²: ' : '') + money(price / 100 / coverage) + (trade ? '' : ' ' + labels.perM2)),
              element('small', 'fmv-tile-vat-label', ' ' + labels.vat)
            );
            const unitPriceContainer = trade && tradeSummary ? tradeSummary : output;
            if (trade || !option.promotion) unitPriceContainer.append(unitPrice);
            if (trade && trade.dataset.taxable === 'true') {
              const netPrice = element('p', 'fmv-tile-net-unit-price', labels.tileTrade.replace(/:\s*$/, '') + ' m²: ' + money(price / 100 / coverage / 1.2) + ' ');
              netPrice.append(element('strong', '', labels.tileExVat));
              unitPriceContainer.append(netPrice);
            }
          } else if (trade && Number.isFinite(retail) && !titleBlock) {
            line(labels.tileRetail + ' ' + money(retail / 100) + ' ' + unit + ' ' + labels.vat);
          }
          const boxPrice = trade && trade.dataset.taxable === 'true'
            ? labels.tileTrade + ' ' + money(Math.round(price / 1.2) / 100) + ' ' + unit + ' ' + labels.tileExVat + ' · ' + money(price / 100) + ' ' + labels.vat
            : (trade ? labels.tileTrade + ' ' : '') + money(price / 100) + ' ' + unit + ' ' + labels.vat;
          if ((!trade || !validCoverage || (option.unit && option.unit !== 'm2')) && (trade || !option.promotion)) line(boxPrice, 'fmv-tile-box-price');
        }
        const total = product.querySelector('fmv-retail-total');
        let totalCoverage = total?.querySelector('.fmv-tile-total-coverage');
        if (total && !totalCoverage) {
          totalCoverage = element('p', 'fmv-tile-total-coverage');
          total.prepend(totalCoverage);
        }
        if (totalCoverage) {
          totalCoverage.replaceChildren();
          const showCoverage = validCoverage && Number.isInteger(quantity) && quantity > 0;
          totalCoverage.hidden = !showCoverage;
          if (showCoverage) {
            const displayedCoverage = (Math.floor(coverage * quantity * 100 + 1e-8) / 100).toFixed(2);
            const [prefix, suffix = ''] = labels.tileCoverage.split('{coverage}');
            totalCoverage.append(
              document.createTextNode(prefix),
              element('strong', '', displayedCoverage + suffix),
              document.createTextNode(' · ' + labels.tileWaste)
            );
          }
        }
        let packInformation = total?.querySelector('.fmv-tile-pack');
        if (total && !packInformation) {
          packInformation = element('p', 'fmv-tile-pack');
          total.prepend(packInformation);
        }
        if (packInformation) {
          packInformation.hidden = !validCoverage || option.unit === 'piece';
          packInformation.textContent = validCoverage && option.unit !== 'piece'
            ? labels.tilePack.replace('{tiles}', String(pack.tiles ?? '—')).replace('{coverage}', (Math.floor(coverage * 100 + 1e-8) / 100).toFixed(2))
            : '';
        }
        const taxNotice = product.querySelector('.product__tax');
        const totalLine = total?.querySelector('[data-total]')?.closest('p');
        if (taxNotice && totalLine && totalLine.nextElementSibling !== taxNotice) totalLine.after(taxNotice);
        const note = product.querySelector('.fmv-retail-total__note');
        if (note) note.textContent = option.unit === 'piece' ? labels.tilePieceNote : labels.tileBoxNote;
      };
      const scheduleUpdate = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      };
      product.addEventListener('change', scheduleUpdate);
      product.addEventListener('input', scheduleUpdate);
      product.addEventListener('fmv:trade-price', scheduleUpdate);
      const price = product.querySelector('[id^="price-"]');
      if (price) new MutationObserver(scheduleUpdate).observe(price, {childList:true,subtree:true,attributes:true});
      update();
    } catch (error) {
      console.warn('Tile pack information unavailable:', error.message);
    }
  }
  function materialsCatalogue() {
    const categories = document.getElementById('materials-categories');
    if (!categories) return;
    const links = [...categories.querySelectorAll('a.fmv-materials-card[href*="/collections/"]')];
    if (!links.length) return;
    const panel = element('section', 'fmv-materials-browser');
    panel.hidden = true;
    panel.tabIndex = -1;
    categories.after(panel);
    const back = element('button', 'fmv-materials-back', '← ' + labels.materialsBack);
    back.type = 'button';
    const heading = element('h2');
    const search = element('input', 'fmv-materials-search');
    search.type = 'search';
    search.placeholder = labels.materialsSearch;
    search.setAttribute('aria-label', labels.materialsSearch);
    const status = element('p');
    status.setAttribute('role', 'status');
    const grid = element('div', 'fmv-materials-products');
    const more = element('button', 'fmv-search-tile-button', labels.materialsMore);
    more.type = 'button';
    more.hidden = true;
    const detail = element('div', 'fmv-materials-detail');
    detail.hidden = true;
    panel.append(back, heading, search, status, grid, more, detail);
    let activeLink, nextUrl, requestId = 0;
    const focusPanel = () => { panel.focus({preventScroll:true}); panel.scrollIntoView({block:'start'}); };
    const showProducts = () => {
      requestId++; status.textContent = '';
      detail.replaceChildren();
      detail.hidden = true;
      grid.hidden = false;
      search.hidden = false;
      more.hidden = !nextUrl;
      heading.textContent = activeLink.querySelector('h3').textContent;
      back.textContent = '← ' + labels.materialsBack;
      focusPanel();
    };
    back.addEventListener('click', () => {
      if (!detail.hidden) return showProducts();
      requestId++;
      panel.hidden = true;
      categories.hidden = false;
      activeLink?.focus();
    });
    async function openProduct(url, title) {
      grid.hidden = true;
      search.hidden = true;
      more.hidden = true;
      detail.hidden = false;
      status.textContent = '';
      heading.textContent = title;
      back.textContent = '← ' + labels.materialsProducts;
      const full = element('a', 'fmv-materials-full', labels.materialsOpen + ' ↗');
      full.href = url;
      detail.replaceChildren(full);
      const id = ++requestId;
      status.textContent = labels.materialsLoading;
      focusPanel();
      try {
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Product unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const main = doc.querySelector('product-info[id^="MainProduct-"]');
        if (id !== requestId) return; if (!main) throw new Error('Product unavailable');
        const section = main.closest('.shopify-section');
        const content = element('div', 'fmv-materials-native-product');
        for (const style of section.querySelectorAll('style')) content.append(style.cloneNode(true));
        main.dataset.updateUrl = 'false';
        content.append(main);
        detail.append(content);
        for (const old of content.querySelectorAll('script[src]')) {
          const src = new URL(old.getAttribute('src'), location.origin).href;
          if ([...document.scripts].some(s => s !== old && s.src === src)) { old.remove(); continue; }
          const script = document.createElement('script');
          script.src = src;
          await new Promise((resolve, reject) => {script.onload = resolve;script.onerror = reject;old.replaceWith(script);});
        }
        if (id !== requestId) return; const data = doc.getElementById('fmv-enquiry-config')?.dataset;
        const variants = JSON.parse(data?.variants || '[]');
        const add = main.querySelector('form.main-product-form button[name="add"]');
        if (add && data) {
          const enquire = element('a', 'fmv-product-enquiry', data.button);
          const update = () => {
            const form = add.closest('form');
            const variantId = form.querySelector('[name="id"]')?.value;
            const variant = variants.find(v => String(v.id) === variantId);
            const productUrl = new URL(url);
            if (variantId) productUrl.searchParams.set('variant', variantId);
            const contact = new URL(root + 'pages/contact-us', location.origin);
            const values = {product:title,option:variant?.title === 'Default Title' ? '' : variant?.title,reference:variant?.sku,quantity:main.querySelector('input[name="quantity"]')?.value || '1',link:productUrl.href};
            for (const [key,value] of Object.entries(values)) if(value) contact.searchParams.set('enquiry_' + key,value);
            contact.hash = 'fmv-product-enquiry-details';
            enquire.href = contact.href;
          };
          update();
          enquire.addEventListener('click', update); main.addEventListener('change', () => setTimeout(update, 500));
          add.after(enquire);
          if (main.classList.contains('fmv-retail-buying')) {
            const sharing = main.querySelector('.fmv-message-sharing');
            if (sharing) {
              enquire.after(sharing.parentElement);
              sharing.addEventListener('click', event => {
                const link = event.target.closest('[data-share-method]');
                if (!link) return;
                const shareUrl = new URL(url);
                const variantId = add.closest('form').elements.namedItem('id')?.value;
                if (variantId) shareUrl.searchParams.set('variant', variantId);
                const message = encodeURIComponent(title + ' — ' + shareUrl.href);
                if (link.dataset.shareMethod === 'whatsapp') link.href = 'https://wa.me/?text=' + message;
                if (link.dataset.shareMethod === 'email') link.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + message;
                if (link.dataset.shareMethod === 'sms') link.href = 'sms:?body=' + message;
              });
            }
          }
        }
        window.Shopify?.PaymentButton?.init();
        document.dispatchEvent(new CustomEvent('quick-view:loaded', {detail:{productUrl:url}}));
        status.textContent = '';
      } catch (error) { if (id === requestId) status.textContent = labels.materialsError; }
    }
    function filter() {
      const term = search.value.trim().toLowerCase();
      for (const card of grid.children) card.hidden = !card.textContent.toLowerCase().includes(term);
    }
    search.addEventListener('input', filter);
    async function loadProducts(url, append = false) {
      const id = ++requestId;
      status.textContent = labels.materialsLoading;
      more.disabled = true;
      try {
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (id !== requestId) return;
        const originals = doc.querySelectorAll('#ProductsList .product-card');
        if (!originals.length) throw new Error('Collection unavailable');
        if (!append) grid.replaceChildren();
        for (const original of originals) {
          const titleLink = original.querySelector('.product-card__title a');
          const originalImage = original.querySelector('.product-card__image--main img');
          const originalPrice = original.querySelector('.f-price');
          if (!titleLink) continue;
          const href = new URL(titleLink.getAttribute('href'), location.origin).href;
          const title = titleLink.textContent.trim();
          const card = element('article', 'fmv-material-product');
          const imageLink = element('a', 'fmv-search-tile-image-link');
          imageLink.href = href;
          const imageFrame = element('span', 'fmv-search-tile-photo');
          if (originalImage) {
            const img = originalImage.cloneNode(true);
            img.removeAttribute('is');
            img.removeAttribute('class');
            img.loading = 'lazy';
            img.sizes = '(max-width:767px) 90vw, 400px';
            imageFrame.append(img);
          }
          imageLink.append(imageFrame);
          const titleHeading = element('h3', '', title);
          const button = element('a', 'fmv-search-tile-button', labels.explore);
          button.href = href;
          button.setAttribute('aria-label', labels.explore + ' ' + title);
          card.append(imageLink, titleHeading);
          if (originalPrice) card.append(originalPrice.cloneNode(true));
          card.append(button);
          grid.append(card);
        }
        const next = doc.querySelector('.pagination a[rel="next"], .pagination__item--next');
        nextUrl = next?.getAttribute('href') ? new URL(next.getAttribute('href'), location.origin).href : null;
        more.hidden = !nextUrl;
        more.disabled = false;
        status.textContent = '';
        filter();
      } catch (error) {
        if (id !== requestId) return;
        const fallback = element('a', '', labels.materialsError);
        fallback.href = activeLink.href;
        status.replaceChildren(fallback);
        more.hidden = true;
      }
    }
    more.addEventListener('click', () => { if (nextUrl) loadProducts(nextUrl, true); });
    for (const link of links) link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.button) return;
      event.preventDefault();
      activeLink = link;
      categories.hidden = true;
      panel.hidden = false;
      nextUrl = null;
      search.value = '';
      showProducts();
      grid.replaceChildren();
      loadProducts(link.href);
    });
  }
  function start() {
    materialsCatalogue();
    nativeTileDetails();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.product-card') || node.querySelector?.('.product-card'))))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    schedule();
    openLinkedCollection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

